import { useAppServices } from "hook/services";
import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  Grid,
  Alert,
  Snackbar
} from "@mui/material";

const CustomFields = () => {
  const Service = useAppServices();
  const [customFields, setCustomFields] = useState([]);
  const [selectedCustomFields, setSelectedCustomFields] = useState({
    listing_name: { field_id: "", field_name: "" },
    host_name: { field_id: "", field_name: "" },
    creator_name: { field_id: "", field_name: "" },
    creator_phone: { field_id: "", field_name: "" },
    message_from_creator: { field_id: "", field_name: "" },
    booking_day: { field_id: "", field_name: "" },
    booking_time: { field_id: "", field_name: "" },
    booking_duration: { field_id: "", field_name: "" },
    purpose_of_booking: { field_id: "", field_name: "" },
    guests: { field_id: "", field_name: "" }
  });
  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(true);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const getCustomFields = async () => {
    try {
      const { response } = await Service.super_admin_settings.list_custom_fields({});
      setCustomFields(response.data.customFields);
    } catch (error) {
      console.error("Error fetching custom fields:", error);
      setError("Failed to fetch available custom fields");
    }
  };

  const getSetting = async () => {
    try {
      setFetching(true);
      const { response } = await Service.super_admin_settings.get();

      if (response.data.customFields) {
        setSelectedCustomFields(prev => ({
          ...prev,
          ...response.data.customFields,
          listing_name: response.data.customFields.listing_name || { field_id: "", field_name: "" },
          host_name: response.data.customFields.host_name || { field_id: "", field_name: "" },
          creator_name: response.data.customFields.creator_name || { field_id: "", field_name: "" },
          creator_phone: response.data.customFields.creator_phone || { field_id: "", field_name: "" },
          message_from_creator: response.data.customFields.message_from_creator || { field_id: "", field_name: "" },
          booking_day: response.data.customFields.booking_day || { field_id: "", field_name: "" },
          booking_time: response.data.customFields.booking_time || { field_id: "", field_name: "" },
          booking_duration: response.data.customFields.booking_duration || { field_id: "", field_name: "" },
          purpose_of_booking: response.data.customFields.purpose_of_booking || { field_id: "", field_name: "" },
          guests: response.data.customFields.guests || { field_id: "", field_name: "" }
        }));
      }
    } catch (error) {
      console.error("Error fetching custom field settings:", error);
      setError("Failed to fetch current custom field settings");
    } finally {
      setFetching(false);
    }
  };

  const handleCustomFieldChange = (type, fieldId) => {
    const selected = customFields.find(f => f.id === fieldId);
    setSelectedCustomFields(prev => ({
      ...prev,
      [type]: {
        field_id: selected?.id || "",
        field_name: selected?.name || ""
      }
    }));
  };

  const saveCustomFields = async () => {
    try {
      setLoading(true);
      console.log(selectedCustomFields, "selectedCustomFields")
      await Service.super_admin_settings.update_custom_fields({
        payload: selectedCustomFields
      });
      setSuccess(true);
    } catch (error) {
      console.error("Error saving custom fields:", error);
      setError("Failed to save custom fields");
    } finally {
      setLoading(false);
    }
  };

  const handleCloseSnackbar = () => {
    setError(null);
    setSuccess(false);
  };

  useEffect(() => {
    const fetchData = async () => {
      await getCustomFields();
      await getSetting();
    };
    fetchData();
  }, []);



  return (
    <>
      <Typography variant="h4" component="h2" gutterBottom style={{ marginTop: "5rem", marginBottom: "2rem" }}>
        Custom Field Settings
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <FormControl fullWidth>
            <InputLabel id="listing-name-label">Listing Name</InputLabel>
            <Select
              labelId="listing-name-label"
              value={selectedCustomFields.listing_name.field_id}
              onChange={(e) => handleCustomFieldChange('listing_name', e.target.value)}
              label="Listing Name"
            >
              <MenuItem value="">
                <em>Select a custom field</em>
              </MenuItem>
              {customFields.map(field => (
                <MenuItem key={field.id} value={field.id}>
                  {field.name} (v{field.version})
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} md={6}>
          <FormControl fullWidth>
            <InputLabel id="host-name-label">Host Name</InputLabel>
            <Select
              labelId="host-name-label"
              value={selectedCustomFields.host_name.field_id}
              onChange={(e) => handleCustomFieldChange('host_name', e.target.value)}
              label="Host Name"
            >
              <MenuItem value="">
                <em>Select a custom field</em>
              </MenuItem>
              {customFields.map(field => (
                <MenuItem key={field.id} value={field.id}>
                  {field.name} (v{field.version})
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} md={6}>
          <FormControl fullWidth>
            <InputLabel id="creator-name-label">Creator Name</InputLabel>
            <Select
              labelId="creator-name-label"
              value={selectedCustomFields.creator_name.field_id}
              onChange={(e) => handleCustomFieldChange('creator_name', e.target.value)}
              label="Creator Name"
            >
              <MenuItem value="">
                <em>Select a custom field</em>
              </MenuItem>
              {customFields.map(field => (
                <MenuItem key={field.id} value={field.id}>
                  {field.name} (v{field.version})
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} md={6}>
          <FormControl fullWidth>
            <InputLabel id="creator-phone-label">Creator Phone</InputLabel>
            <Select
              labelId="creator-phone-label"
              value={selectedCustomFields.creator_phone.field_id}
              onChange={(e) => handleCustomFieldChange('creator_phone', e.target.value)}
              label="Creator Phone"
            >
              <MenuItem value="">
                <em>Select a custom field</em>
              </MenuItem>
              {customFields.map(field => (
                <MenuItem key={field.id} value={field.id}>
                  {field.name} (v{field.version})
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} md={6}>
          <FormControl fullWidth>
            <InputLabel id="message-from-creator-label">Message from Creator</InputLabel>
            <Select
              labelId="message-from-creator-label"
              value={selectedCustomFields.message_from_creator.field_id}
              onChange={(e) => handleCustomFieldChange('message_from_creator', e.target.value)}
              label="Message from Creator"
            >
              <MenuItem value="">
                <em>Select a custom field</em>
              </MenuItem>
              {customFields.map(field => (
                <MenuItem key={field.id} value={field.id}>
                  {field.name} (v{field.version})
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} md={6}>
          <FormControl fullWidth>
            <InputLabel id="booking-day-label">Booking Day</InputLabel>
            <Select
              labelId="booking-day-label"
              value={selectedCustomFields.booking_day.field_id}
              onChange={(e) => handleCustomFieldChange('booking_day', e.target.value)}
              label="Booking Day"
            >
              <MenuItem value="">
                <em>Select a custom field</em>
              </MenuItem>
              {customFields.map(field => (
                <MenuItem key={field.id} value={field.id}>
                  {field.name} (v{field.version})
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} md={6}>
          <FormControl fullWidth>
            <InputLabel id="booking-time-label">Booking Time</InputLabel>
            <Select
              labelId="booking-time-label"
              value={selectedCustomFields.booking_time.field_id}
              onChange={(e) => handleCustomFieldChange('booking_time', e.target.value)}
              label="Booking Time"
            >
              <MenuItem value="">
                <em>Select a custom field</em>
              </MenuItem>
              {customFields.map(field => (
                <MenuItem key={field.id} value={field.id}>
                  {field.name} (v{field.version})
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} md={6}>
          <FormControl fullWidth>
            <InputLabel id="booking-duration-label">Booking Duration</InputLabel>
            <Select
              labelId="booking-duration-label"
              value={selectedCustomFields.booking_duration.field_id}
              onChange={(e) => handleCustomFieldChange('booking_duration', e.target.value)}
              label="Booking Duration"
            >
              <MenuItem value="">
                <em>Select a custom field</em>
              </MenuItem>
              {customFields.map(field => (
                <MenuItem key={field.id} value={field.id}>
                  {field.name} (v{field.version})
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} md={6}>
          <FormControl fullWidth>
            <InputLabel id="purpose-of-booking-label">Purpose of Booking</InputLabel>
            <Select
              labelId="purpose-of-booking-label"
              value={selectedCustomFields.purpose_of_booking.field_id}
              onChange={(e) => handleCustomFieldChange('purpose_of_booking', e.target.value)}
              label="Purpose of Booking"
            >
              <MenuItem value="">
                <em>Select a custom field</em>
              </MenuItem>
              {customFields.map(field => (
                <MenuItem key={field.id} value={field.id}>
                  {field.name} (v{field.version})
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} md={6}>
          <FormControl fullWidth>
            <InputLabel id="guests-label">Guests</InputLabel>
            <Select
              labelId="guests-label"
              value={selectedCustomFields.guests.field_id}
              onChange={(e) => handleCustomFieldChange('guests', e.target.value)}
              label="Guests"
            >
              <MenuItem value="">
                <em>Select a custom field</em>
              </MenuItem>
              {customFields.map(field => (
                <MenuItem key={field.id} value={field.id}>
                  {field.name} (v{field.version})
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12}>
          <Button
            onClick={saveCustomFields}
            disabled={loading}
            fullWidth
            size="large"
            style={{ background: "#3F98EF", color: "white", marginTop: "2rem" }}
            variant="contained"
          >
            {loading ? <CircularProgress size={24} color="inherit" /> : 'Save Custom Fields'}
          </Button>
        </Grid>
      </Grid>

      <Snackbar
        open={error !== null}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
      >
        <Alert onClose={handleCloseSnackbar} severity="error" sx={{ width: '100%' }}>
          {error}
        </Alert>
      </Snackbar>

      <Snackbar
        open={success}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
      >
        <Alert onClose={handleCloseSnackbar} severity="success" sx={{ width: '100%' }}>
          Custom fields saved successfully!
        </Alert>
      </Snackbar>
    </>
  );
};

export default CustomFields;